var map = {
  "./messages_id.json": [
    "12064",
    "2377"
  ],
  "./messages_th.json": [
    "54453",
    "9382"
  ],
  "./messages_uk.json": [
    "92005",
    "3478"
  ],
  "./messages_it.json": [
    "69808",
    "2953"
  ],
  "./messages_en.json": [
    "52582",
    "6699"
  ],
  "./messages_es.json": [
    "69658",
    "3038"
  ],
  "./messages_sv.json": [
    "29284",
    "4261"
  ],
  "./messages_tr.json": [
    "23667",
    "1520"
  ],
  "./messages_hi.json": [
    "97974",
    "347"
  ],
  "./messages_ru.json": [
    "44176",
    "5033"
  ],
  "./messages_de.json": [
    "19793",
    "2115"
  ],
  "./messages_ko.json": [
    "75975",
    "7580"
  ],
  "./messages_fr.json": [
    "38005",
    "550"
  ],
  "./messages_fi.json": [
    "9200",
    "7881"
  ],
  "./messages_ja.json": [
    "19172",
    "213"
  ],
  "./messages_cs.json": [
    "38395",
    "2376"
  ],
  "./messages_da.json": [
    "22850",
    "7023"
  ],
  "./messages_no.json": [
    "7942",
    "1131"
  ],
  "./messages_pt.json": [
    "83797",
    "3574"
  ],
  "./messages_vi.json": [
    "14720",
    "617"
  ],
  "./messages_zh.json": [
    "49583",
    "3812"
  ],
  "./messages_nl.json": [
    "60135",
    "9740"
  ],
  "./messages_pl.json": [
    "70861",
    "7566"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 43656;
module.exports = __rspack_async_context;
